<template>
    <div>
<!--body content start-->

<div id="main-page" class="page-content">

<!--contact start-->

<section class="p-0">
  <div class="container-fluid p-0">
    <div class="row no-gutters">
      <div class="col-md-6">
        <div class="p-5">
          <div class="section-title">
            <h6>Contact Us</h6>
            <h2 class="title">Let's Start <span>Conversation</span></h2>
            <p>Get in touch and let us know how we can help. Fill out the form and we’ll be in touch as soon as possible.</p>
          </div>
          <div class="contact-main">
            <form id="contact-form" class="row" method="post" action="http://themeht.com/agencio/rtl/php/contact.php">
              <div class="messages"></div>
              <div class="form-group col-md-6">
                <input id="form_name" type="text" name="firstname" class="form-control" placeholder="First Name" required="required" data-error="Name is required.">
                <div class="help-block with-errors"></div>
              </div>
              <div class="form-group col-md-6">
                <input id="form_name1" type="text" name="lastname" class="form-control" placeholder="Last Name" required="required" data-error="Name is required.">
                <div class="help-block with-errors"></div>
              </div>
              <div class="form-group col-md-6">
                <input id="form_email" type="email" name="email" class="form-control" placeholder="Email" required="required" data-error="Valid email is required.">
                <div class="help-block with-errors"></div>
              </div>
              <div class="form-group col-md-6">
                <input id="form_phone" type="tel" name="phone" class="form-control" placeholder="Phone" required="required" data-error="Phone is required">
                <div class="help-block with-errors"></div>
              </div>
              <div class="form-group col-md-12">
                <textarea id="form_message" name="message" class="form-control" placeholder="Message" rows="4" required="required" data-error="Please,leave us a message."></textarea>
                <div class="help-block with-errors"></div>
              </div>
              <div class="col-md-12 mt-4">
                <button class="btn btn-theme"><span>Send Messages <i class="far fa-paper-plane ml-2"></i></span>
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="mt-5 dark-bg p-5 contact-info pos-r"> <i class="flaticon-support"></i>
          <div class="contact-media mb-4"> <i class="flaticon-location"></i>
            <h6>Address:</h6>
            <span>423B, Road Wordwide Country, USA</span>
          </div>
          <div class="contact-media mb-4"> <i class="flaticon-email"></i>
            <h6>Email Us</h6>
            <a href="mailto:themeht23@gmail.com"> themeht23@gmail.com</a>
          </div>
          <div class="contact-media"> <i class="flaticon-support-1"></i>
            <h6>Call Us</h6>
            <a href="tel:+912345678900">+91-234-567-8900</a>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="map h-100">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.840108181602!2d144.95373631539215!3d-37.8172139797516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65d4c2b349649%3A0xb6899234e561db11!2sEnvato!5e0!3m2!1sen!2sin!4v1497005461921" allowfullscreen=""></iframe>
        </div>
      </div>
    </div>
  </div>
</section>

<!--contact end-->

</div>

<!--body content end--> 

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            name: 'contact',
        }
    },
};
</script>